/*
 * @Date: 2022-07-04 16:41:51
 * @LastEditors: chuhongguang
 */
import layout from './modules/layout'
import view from './modules/views'

export default {
  layout,
  view
}
